import { RootState } from "@/store/store";
import { resourceExplorerStateSelector } from "@/store/resource-explorer/selectors/resourceExplorerStateSelector";

export const billingExplorerChartTypeSelector = (state: RootState) => {
  return resourceExplorerStateSelector(state).chartType;
};
